import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import "./SavingCloserRequest.css";
import { Link } from "react-router-dom";


import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";

const SavingCloserRequest = () => {
    const { profile } = useSelector((state) => state.userProfile);
    const dispatch = useDispatch();
  
  const [activeTab, setActiveTab] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [accountType, setAccountType] = useState("");
  const [branch, setBranch] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [accountsData, setAccountsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
    const [closerDate, setCloserDate] = useState("");
    const [closerRemark, setCloserRemark] = useState("");
      const [accountCloseDialog, setAccountCloseDialog] = useState({
        open: false,
        accountId: null,
      });

  const rowsPerPage = 10;

// Load profile on mount
useEffect(() => {
  dispatch(fetchUserProfile());
}, [dispatch]);

console.log("profile data",profile);

  useEffect(() => {
    if (!profile?.superAdminId || !profile?.branchId) return;
    fetchAccounts();
  }, [profile]);

// Your API call
const fetchAccounts = async () => {
  try {
    setLoading(true);
    setError("");

    const superAdminId = profile?.superAdminId || 14;
    const branchId = profile?.branchId || 8;
    const createdBy = localStorage.getItem("userId") || 56;

    const response = await axios.get(
      "https://narrowitsolution.in/api/get-all-saving-account",
      { params: { superAdminId, branchId, createdBy } }
    );

    if (Array.isArray(response.data.accounts)) {
      setAccountsData(response.data.accounts);
    } else {
      setAccountsData([]);
    }
  } catch (error) {
    console.error("API Error:", error);
    setError("Failed to load saving accounts.");
  } finally {
    setLoading(false);
  }
};




  const openAccountCloseDialog = (accountId) => {
    setAccountCloseDialog({ open: true, accountId });
  };

  const closeAccountCloseDialog = () => {
    setAccountCloseDialog({ open: false, accountId: null });
    setCloserDate("");
    setCloserRemark("");
  };

  const handleSavingAccountClose = async (e) => {
    e.preventDefault();

    if (!closerDate || !closerRemark) {
      toast.error("Date and remark required");
      return;
    }

    try {
      const res = await axios.put(
        `https://narrowitsolution.in/api/saving-account/request-close/${accountCloseDialog.accountId}`,
        {
          closureRemark: closerRemark,
          closureDate: closerDate,
        }
      );

      console.log(res);
      toast.success("Account Closure Reuested successfully");
      fetchAccounts();
      closeAccountCloseDialog();
    } catch (err) {
      toast.error(err?.response?.data?.message||"Failed to close saving account");
      // console.error(err);
    }
  };




  // ✅ Tabs: All / Active / Closed / Pre-Closed / Reject
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setCurrentPage(1);
    setSelectedRow(null);
  };

  // ✅ Filtered Data
  const filteredData = useMemo(() => {
    let data = [...accountsData];
    console.log("shaving report data: ",data)
    
    data = data.filter((item) => item.status === "Active");
    // Tab filter
    if (activeTab !== "All") data = data.filter((item) => item.status === activeTab);

    // Search
    if (searchQuery.trim()) {
      data = data.filter((item) =>
        Object.values(item)
          .join(" ")
          .toLowerCase()
          .includes(searchQuery.toLowerCase())
      );
    }

    // Account Type filter
    if (accountType) data = data.filter((item) => item.accountType === accountType);

    // Date filters
    if (fromDate)
      data = data.filter((item) => new Date(item.openedDate) >= new Date(fromDate));
    if (toDate)
      data = data.filter((item) => new Date(item.openedDate) <= new Date(toDate));

    return data;
  }, [accountsData, activeTab, searchQuery, accountType, fromDate, toDate]);

  // ✅ Pagination
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const paginatedData =
    activeTab === "All"
      ? filteredData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage)
      : filteredData;


  return (
    <div className="saving-acc-closer-req-container">
      <h2 className="saving-acc-closer-req-title">Saving Account Closer Request</h2>

    

      {/* Filters */}
      <div className="saving-acc-closer-req-filters">
        <input
          type="text"
          placeholder="Search by name, account no..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        <select value={accountType} onChange={(e) => setAccountType(e.target.value)}>
          <option value="">All Account Types</option>
          <option value="Saving">Saving</option>
          <option value="Current">Current</option>
        </select>
        <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
        <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
        <button className="saving-acc-closer-req-filter-apply-btn" onClick={() => setCurrentPage(1)}>
          Apply
        </button>
        <button
          className="saving-acc-closer-req-filter-reset-btn"
          onClick={() => {
            setSearchQuery("");
            setAccountType("");
            setFromDate("");
            setToDate("");
            setActiveTab("All");
          }}
        >
          Reset
        </button>
      </div>

      {/* Loading / Error States */}
      {loading && <p className="saving-acc-closer-req-loading-div">Loading saving accounts...</p>}
      {error && <p className="saving-acc-closer-req-error-div">{error}</p>}

      {/* Table */}
      <div className="saving-acc-closer-req-table-container">
        <table className="saving-acc-closer-req-table">
          <thead>
            <tr>
              <th>SN</th>
              <th>Account No</th>
              <th>Customer Name</th>
              <th>Account Type</th>
              <th>Opened Date</th>
              <th>Status</th>
              {/* <th>Opening Balance</th>
              <th>Current Balance</th>
              <th>Share Certificate</th>
              <th>Passbook</th> */}
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.length > 0 ? (
              paginatedData.map((item, index) => (
                <tr  className={
                        item.status.toLowerCase() === "closed"
                          ? "closed-row"
                          : item.status.toLowerCase() === "closerequested"
                            ? "requested-row"
                            : ""
                      } key={item.id || index}>
                  <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                  <td>{item.accountNumber || "--"}</td>
                  <td>{item.customerName || "--"}</td>
                  <td>{item.accountType || "--"}</td>
                  <td>{new Date(item.openedDate).toLocaleDateString("en-GB").replaceAll("/","-")|| "--"}</td>
                  <td className={`Status-${item.status.toLowerCase()}`}>{item.status || "--"}</td>
                  {/* <td>₹{item.openingBalance || "0"}</td>
                  <td>₹{item.currentBalance || "0"}</td>
                  <td><Link className="share-cirtificate-open-btn" to={"/Banking/Report/SharesCertificates"} state={{ row: item }}>Open</Link></td>
                  <td><Link className="demo-report-open-btn" to={"/Banking/Report/SavingPassbook"} state={{ row: item }}>Open</Link></td>
                  <td>
                    <button
                      className="Demoview-btn"
                      onClick={() => setSelectedRow(item)}
                    >
                      View
                    </button>
                  </td> */}
                  <td>
                   {item.status.toLowerCase()==="closerequested" || item.status.toLowerCase()==="closed" ?(
                     <button
                      className={`saving-acc-closer-req-table-action-btn ${item.status.toLowerCase()==="closed"?"closed-btn":"requested-btn"}`}
                       disabled
                            aria-disabled="true"
                            title={
                              item.status.toLowerCase() === "closed"
                                ? "Account already closed"
                                : "Account close requested"
                            }
                    >
                      {item.status}
                    </button>
                   ):(
                     <button
                      className="saving-acc-closer-req-table-action-btn"
                      onClick={() => openAccountCloseDialog(item.id)}
                    >
                      Close
                    </button>
                   )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                {loading ? <td colSpan="11" style={{ textAlign: "center" }}>
                  Loading....
                </td>:<td colSpan="11" style={{ textAlign: "center" }}>
                  No Data Found
                </td>}
                
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {activeTab === "All" && filteredData.length > rowsPerPage && (
        <div className="saving-acc-closer-req-pagination-section">
          <button onClick={() => setCurrentPage((p) => p - 1)} disabled={currentPage === 1}>
            Previous
          </button>
          <span>
            Page {currentPage} of {totalPages || 1}
          </span>
          <button
            onClick={() => setCurrentPage((p) => p + 1)}
            disabled={currentPage === totalPages || totalPages === 0}
          >
            Next
          </button>
        </div>
      )}


      {/* Loan Close Confirmation Dialog */}
      {accountCloseDialog.open && (
        <div className="account-closer-dialog-overlay">
          <div className="account-closer-dialog">
            <h3>Saving Account Close Confirmation</h3>

            <form onSubmit={handleSavingAccountClose}>
              <input
                type="date"
                value={closerDate}
                onChange={(e) => setCloserDate(e.target.value)}
              />
              <input
                type="text"
                placeholder="Remark"
                value={closerRemark}
                onChange={(e) => setCloserRemark(e.target.value)}
              />

              <div className="account-closer-dialog-buttons">
                <button type="submit" className="btn-confirm">
                  Close
                </button>
                <button
                  type="button"
                  onClick={closeAccountCloseDialog}
                  className="btn-cancel"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default SavingCloserRequest;
